import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { queryKeys } from "./queryKeys.ts";

export const useRemoveCardFromEditViewsCache = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (cardId: string) => {
      queryClient.removeQueries({
        queryKey: queryKeys.cardEditViewsOfCard(cardId),
      });
    },
    [queryClient],
  );
};
